import { DesktopGridItem } from 'shared/types/desktop-grid'

import {
  checkSlotFits,
  createGrid,
  markSlotOccupied
} from '../gridLayoutHelpers'

export const applySequentialPlacement = (
  sortedItems: DesktopGridItem[],
  cols: number,
  rows: number,
  originalItems: DesktopGridItem[]
) => {
  if (!sortedItems.length || cols <= 0 || rows <= 0) return sortedItems

  const grid = createGrid(rows, cols)
  const placedItems: DesktopGridItem[] = []

  const pinnedItems = sortedItems.filter(item => item.isPinned)
  const pinnedIds = new Set(pinnedItems.map(item => item.id))

  pinnedItems.forEach(item => {
    placedItems.push(item)
    if (
      checkSlotFits(
        grid,
        item.position.row,
        item.position.col,
        item.size.width,
        item.size.height,
        rows,
        cols
      )
    ) {
      markSlotOccupied(
        grid,
        item.position.row,
        item.position.col,
        item.size.width,
        item.size.height
      )
    }
  })

  sortedItems
    .filter(item => !pinnedIds.has(item.id))
    .forEach(item => {
      let placed = false
      for (let row = 0; row < rows && !placed; row += 1) {
        for (let col = 0; col < cols && !placed; col += 1) {
          if (
            !checkSlotFits(
              grid,
              row,
              col,
              item.size.width,
              item.size.height,
              rows,
              cols
            )
          )
            continue

          markSlotOccupied(grid, row, col, item.size.width, item.size.height)
          placedItems.push({
            ...item,
            position: { row, col }
          })
          placed = true
        }
      }

      if (!placed) {
        placedItems.push(item)
      }
    })

  const originalOrder = originalItems.reduce<Record<string, number>>(
    (acc, item, idx) => {
      acc[item.id] = idx
      return acc
    },
    {}
  )

  placedItems.sort((a, b) => originalOrder[a.id] - originalOrder[b.id])

  return placedItems
}
